import React, { useState, useEffect } from 'react';
import {
    Row,
    Col,
    Button,
} from 'react-bootstrap';
import { DataTable, Filter, Header, PageWrapper } from '../../components';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../../shared/enums';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { DATETIME_FORMAT } from '../../shared/constants';
import { getAttempList } from '../../api/attemp';

const Attemp = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const [filter, setFilter] = useState({});
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setPagination(prev => ({ ...prev, page: 1 })); // Reset to page 1 when filter changes
    };

    const columns = [
        { key: "totalQuestions", label: t("TOTAL_QUESTION") },
        { key: "correctAnswersCount", label: t("CORRECT_ANSWER_COUNT") },
        { key: "score", label: t("SCORE"), render: (score, data) => score.toFixed(2) },
        { key: "user", label: t("USER"), render: (user, data) => user.fullName },
        { key: "createdAt", label: t("CREATED_AT"), render: (createdAt, data) => dayjs(createdAt).format(DATETIME_FORMAT), },
        {
            key: "action", label: t("ACTION"), render: (v, data) => <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm" className='py-0'></Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate(Pages.AttemptDetail.replace(":id", data.id))}>{t("DETAIL")}</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        }
    ]

    const filters = [
        { type: "datetime", label: t("FORM_DATE"), name: "fromDate" },
        { type: "datetime", label: t("TO_DATE"), name: "toDate" },
    ];

    useEffect(() => {
        getData(pagination, filter)
    }, [pagination, filter])

    const getData = async (pagination, filter) => {
        const response = await getAttempList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize, ...filter })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    return (
        <PageWrapper headerProps={{ title: "ATTEMPT" }} >
            <Filter filters={filters} onChangeFilter={handleFilterChange} />
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />
        </PageWrapper>
    );
};

export default Attemp;
